import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { createToolbarEvent } from "../../../analytics/AnalyticsEvents";
import { sendAnalytics } from "../../../analytics/functions";
import { leaveConference } from "../../../base/conference/actions.any";
import { BUTTON_TYPES } from "../../../base/ui/constants.web";
import { HangupContextMenuItem } from "./HangupContextMenuItem";
import { ensureDeviceId } from "../../../auth/functions";
import { authApi } from "../../../auth/api";
import { setHangupMenuVisible, setLeavingOverlay } from "../../actions.web";
/**
 * Button to leave the conference.
 *
 * @param {Object} props - Component's props.
 * @returns {JSX.Element} - The leave conference button.
 */
export const LeaveConferenceButton = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const onLeaveConference = useCallback(async () => {
        // Close the hangup menu immediately
        dispatch(setHangupMenuVisible(false));
        dispatch(setLeavingOverlay(true));
        // فوراً کنفرانس رو ترک می‌کنیم
        sendAnalytics(createToolbarEvent("hangup"));
        dispatch(leaveConference());
        // بعد API رو صدا می‌زنیم (fire and forget)
        const roomName = window.location.pathname.slice(1).toLowerCase();
        const deviceId = ensureDeviceId();
        authApi.exitRoom(roomName, deviceId).catch((error) => {
            console.warn("exitRoom API failed", error);
        });
    }, [dispatch]);
    return (React.createElement(HangupContextMenuItem, { accessibilityLabel: t("toolbar.accessibilityLabel.leaveConference"), buttonKey: props.buttonKey, buttonType: BUTTON_TYPES.SECONDARY, label: t("toolbar.leaveConference"), notifyMode: props.notifyMode, onClick: onLeaveConference }));
};
